import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/navbar.component";
import Footer from "../components/footer.component";

const VideoDashboard = () => {
  return (
    <>
      <Navbar />
      <div className="d-flex flex-column align-items-center" style={{ minHeight: "60vh", padding: "60px 20px" }}>
        <h1 className="display-4" style={{ fontWeight: "bold", marginBottom: "20px" }}>
          Video Results Dashboard
        </h1>
        <p className="text-muted fs-5" style={{ maxWidth: "720px", textAlign: "center", marginBottom: "30px" }}>
          This page is a placeholder for visual emotion analytics. Connect your backend model output
          to render confidence charts, timeline trends, and interview summary insights.
        </p>
        <Link to="/video">
          <button type="button" className="btn btn-dark px-4 py-2">
            Back to Video Interview
          </button>
        </Link>
      </div>
      <Footer />
    </>
  );
};

export default VideoDashboard;
